// extracted by mini-css-extract-plugin
export default {"hidden":"Certificado_hidden__z5nJK","form":"Certificado_form__-VF+C","content":"Certificado_content__VPwes","link":"Certificado_link__6VqWZ"};